import React from "react";

const DropDownSelect = ({ items, setYear, year }) => {
  const handleChange = (e) => {
    setYear(e.target.value);
  };
  return (
    <select id="dropdown" onChange={handleChange}>
      {items?.map((item) => (
        <option key={item} value={item}>
          {item}
        </option>
      ))}
    </select>
  );
};

export default DropDownSelect;
